import { useQuery } from '@tanstack/react-query';
import { IPC_AUDIO_DEVICE_CHANNELS } from '../../../../../../../dualChannel/dualChannelApis';

export default function useInputDevices() {
  const query = useQuery({
    queryKey: [IPC_AUDIO_DEVICE_CHANNELS.LIST_INPUT_DEVICES],
    queryFn: async () => {
      const devices = await window.audioDeviceAPI.listInputDevices();
      return devices;
    },
  });
  return query;
}
